  import firebase from 'firebase/app'
  import 'firebase/firestore'
  
  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  var firebaseConfig = {
    apiKey: "AIzaSyBbiyAQLNmPY4xe9wzUD5KmCvsTCYoFpVI",
    authDomain: "portfolio-nicolas.firebaseapp.com",
    databaseURL: "https://portfolio-nicolas.firebaseio.com",
    projectId: "portfolio-nicolas",
    storageBucket: "portfolio-nicolas.appspot.com",
    messagingSenderId: "339039856798",
    appId: "1:339039856798:web:466b1cfc05d7afa4df338f",
    measurementId: "G-LS6T6H1R2Z"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  export const db = firebase.firestore()
  db.settings({ timeStampsInSnapshots: true})
  
  // firebase.analytics();
